<template>
    <div class="overlay">
        <div class="container">
            <div class="content">
                <div>您尚未完成申請，若確認離開系統，您所填寫的資料不會被儲存；<br>離開後再進行申請，則要重新填寫。</div>
            </div>
            <div class="btn-container">
                <a class="btn" href="/sc/client/prepare">確認離開</a>
                <div class="btn" @click="close">繼續申請</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "leaveAlert",
        props:{
            close: Function
        },
        data: () => ({

        }),
        components: {
        },
        methods:{
//            leaveForm(){
//                window.parent.closeIframe();
//            }
        }
    }
</script>

<style lang="scss">
</style>
